// src/pages/DoronDefeated.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function DoronDefeated() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#070E1A] text-white flex flex-col items-center">
      {/* Header */}
      <header className="w-full max-w-4xl px-4 py-6">
        <h1 className="text-4xl md:text-5xl font-extrabold">🎉 Congratulations!</h1>
        <p className="mt-2 text-lg opacity-90">
          You defeated <span className="font-bold">DORON</span> and turned him into a stone statue.
        </p>
      </header>

      {/* Main */}
      <main className="w-full max-w-4xl px-4 pb-16">
        <div className="bg-[#0E1B2E] rounded-2xl shadow-xl p-5 md:p-8">
          {/* Victory artwork — smaller, centered, natural aspect */}
          <figure className="mx-auto w-full max-w-[600px] md:max-w-[680px] lg:max-w-[720px] rounded-xl overflow-hidden bg-black/30 border border-white/10">
            <img
              src="/images/Victory-Image.png"
              alt="Treblins rejoice in the town square while Pan and Wis cheer; Doron stands as a stone statue."
              className="w-full h-auto block"
              loading="eager"
              decoding="async"
              draggable="false"
            />
            <figcaption className="sr-only">
              Treblins Rejoice in the Town Square — Pan &amp; Wis cheer: “Yay! We’re free to roam Treble Town without fear!”
            </figcaption>
          </figure>

          {/* Actions */}
          <div className="mt-5 flex flex-col sm:flex-row gap-3 sm:justify-center">
            <button
              onClick={() => navigate("/certificate")}
              className="px-5 py-3 rounded-xl bg-white text-black font-semibold hover:opacity-90"
            >
              View Your Treblin Town Certificate
            </button>
            <button
              onClick={() => navigate("/")}
              className="px-5 py-3 rounded-xl bg-transparent border border-white/40 font-semibold hover:bg-white/10"
            >
              Back to Home
            </button>
          </div>
        </div>

        {/* Footer hint */}
        <div className="mt-6 opacity-70 text-sm text-center">
          Tip: You can revisit any chapter from the sidebar anytime.
        </div>
      </main>
    </div>
  );
}
